import { useAuthContext } from '@fhs-legacy/frontend/src/state/auth';
import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';
import { flagDefinitions } from '@fhs-legacy/frontend/src/utils/launchdarkly/flags';

export function useHolidayMatchBannerConfig() {
  const { isAuthenticated } = useAuthContext();
  const config = useFlag('enable-braze-game-banner');
  const resolvedConfig = {
    ...flagDefinitions['enable-braze-game-banner'].defaultValue,
    ...config,
  };

  return {
    ...resolvedConfig,
    enabled: isAuthenticated && resolvedConfig.enabled,
  };
}
